/*
  <skigrin-bundle> — "Bundle & save": 1 t/m 4 maskers, per stuk een eigen variantkeuze,
  oplopende korting, en alles in één keer in de winkelwagen.

  Let op: het thema kan geen prijzen verlagen. Dit blok laat de korting alleen zien.
  De echte korting moet als automatische korting in de Shopify-admin staan —
  zie TODO-voor-livegang.md.
*/

/** Shopify-geldformaat toepassen op een bedrag in centen. */
function skigrinFormatMoney(cents, format) {
  const value = Math.round(cents);

  function withSeparators(number, decimals, thousands, decimal) {
    const fixed = (number / 100).toFixed(decimals);
    const parts = fixed.split('.');
    const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    return decimals > 0 && parts[1] ? whole + decimal + parts[1] : whole;
  }

  const placeholder = /\{\{\s*(\w+)\s*\}\}/;
  const match = format.match(placeholder);
  const token = match ? match[1] : 'amount';

  let amount;
  switch (token) {
    case 'amount_no_decimals':
      amount = withSeparators(value, 0, ',', '.');
      break;
    case 'amount_with_comma_separator':
      amount = withSeparators(value, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      amount = withSeparators(value, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      amount = withSeparators(value, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      amount = withSeparators(value, 0, ' ', ',');
      break;
    case 'amount_with_space_separator':
      amount = withSeparators(value, 2, ' ', ',');
      break;
    default:
      amount = withSeparators(value, 2, ',', '.');
  }

  return format.replace(placeholder, amount);
}

class SkigrinBundle extends HTMLElement {
  connectedCallback() {
    this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
    this.variants = this.parseVariants();
    this.tiers = Array.from(this.querySelectorAll('[data-tier]'));
    this.submitButton = this.querySelector('[data-submit]');
    this.errorTarget = this.querySelector('[data-error]');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!this.tiers.length || !this.variants.length) return;

    this.tiers.forEach((tier) => {
      tier.querySelector('.skigrin-tier__input').addEventListener('change', () => this.selectTier(tier));
      tier.querySelectorAll('[data-pick]').forEach((select) => {
        select.addEventListener('change', () => {
          // Zodra iemand zelf kiest, laten we die keuze staan bij een variantwissel.
          select.dataset.touched = 'true';
          this.renderPrices();
        });
      });

      // Foto-keuzeknoppen per gezicht: zetten alleen de waarde van de bijbehorende
      // (verborgen) <select> en vuren een 'change'-event erop af, zodat de rest
      // hierboven — ongewijzigd — gewoon blijft werken.
      tier.querySelectorAll('.skigrin-tier__pick').forEach((pick) => {
        const select = pick.querySelector('[data-pick]');
        if (!select) return;
        pick.querySelectorAll('[data-swatch]').forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
            // Niet laten doorbubbelen naar de omsluitende tier-<label>, anders
            // wisselt een foto-keuze per ongeluk ook de gekozen tier.
            event.preventDefault();
            event.stopPropagation();
            if (swatch.disabled) return;

            select.value = swatch.dataset.variantId;
            select.dispatchEvent(new Event('change', { bubbles: true }));

            pick.querySelectorAll('[data-swatch]').forEach((candidate) => {
              candidate.classList.toggle('is-selected', candidate === swatch);
            });
          });
        });
      });
    });

    if (this.submitButton) {
      this.submitButton.addEventListener('click', () => this.addToCart());
    }

    // Meelopen met de variantkiezer boven het blok, maar alleen voor keuzes
    // die de bezoeker nog niet zelf heeft aangepast.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const id = event?.data?.variant?.id;
        if (!id) return;
        this.querySelectorAll('[data-pick]').forEach((select) => {
          if (select.dataset.touched === 'true') return;
          if (!select.querySelector(`option[value="${id}"]`)) return;
          select.value = String(id);
          // De foto-knoppen van deze pick meenemen, anders blijft de oude
          // foto gemarkeerd terwijl de verborgen select al is meeverschoven.
          select
            .closest('.skigrin-tier__pick')
            ?.querySelectorAll('[data-swatch]')
            .forEach((swatch) => {
              swatch.classList.toggle('is-selected', swatch.dataset.variantId === String(id));
            });
        });
        this.renderPrices();
      });
    }

    const checked = this.tiers.find((tier) => tier.querySelector('.skigrin-tier__input').checked);
    this.selectTier(checked || this.tiers[0]);
  }

  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }

  parseVariants() {
    const node = this.querySelector('[data-variant-json]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('skigrin-bundle: variantdata onleesbaar', error);
      return [];
    }
  }

  selectTier(tier) {
    this.tiers.forEach((candidate) => {
      const isSelected = candidate === tier;
      candidate.classList.toggle('skigrin-tier--selected', isSelected);
      const input = candidate.querySelector('.skigrin-tier__input');
      if (isSelected && !input.checked) input.checked = true;

      const picks = candidate.querySelector('[data-picks]');
      if (picks) picks.hidden = !isSelected;
    });

    this.selected = tier;
    this.renderPrices();
  }

  /** Alle varianten van één tier, in de volgorde van de keuzelijsten. */
  variantsForTier(tier) {
    const quantity = parseInt(tier.dataset.qty, 10) || 1;
    const selects = Array.from(tier.querySelectorAll('[data-pick]'));

    if (selects.length) {
      return selects.map((select) => this.variantById(select.value)).filter(Boolean);
    }

    // Eén variant in het product: dan is er niets te kiezen.
    const fallback = this.variants[0];
    return Array.from({ length: quantity }, () => fallback);
  }

  variantById(id) {
    return this.variants.find((variant) => String(variant.id) === String(id));
  }

  renderPrices() {
    this.tiers.forEach((tier) => {
      const discount = parseInt(tier.dataset.discount, 10) || 0;
      const chosen = this.variantsForTier(tier);
      if (!chosen.length) return;

      // Per stuk afronden en dan optellen, net zoals Shopify een automatische
      // korting per winkelwagenregel afrondt. Op het totaal afronden wijkt een
      // cent af van wat de checkout uiteindelijk rekent.
      const total = chosen.reduce(
        (sum, variant) => sum + Math.round((variant.price * (100 - discount)) / 100),
        0
      );
      const was = chosen.reduce((sum, variant) => sum + (variant.compare_at_price || variant.price), 0);
      const perUnit = Math.round(total / chosen.length);

      const totalTarget = tier.querySelector('[data-total]');
      const wasTarget = tier.querySelector('[data-was]');
      const perTarget = tier.querySelector('[data-per]');

      if (totalTarget) totalTarget.textContent = skigrinFormatMoney(total, this.moneyFormat);
      if (perTarget) {
        perTarget.textContent = perTarget.dataset.template.replace(
          '[price]',
          skigrinFormatMoney(perUnit, this.moneyFormat)
        );
      }
      if (wasTarget) {
        if (was > total) {
          wasTarget.textContent = skigrinFormatMoney(was, this.moneyFormat);
          wasTarget.hidden = false;
        } else {
          wasTarget.hidden = true;
        }
      }
    });
  }

  showError(message) {
    if (this.errorTarget) this.errorTarget.textContent = message || '';
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;
    this.submitButton.classList.toggle('loading', isLoading);
    if (isLoading) {
      this.submitButton.setAttribute('aria-disabled', 'true');
    } else {
      this.submitButton.removeAttribute('aria-disabled');
    }
    const spinner = this.submitButton.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  addToCart() {
    if (!this.selected) return;
    if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.showError('');

    const chosen = this.variantsForTier(this.selected);
    if (!chosen.length) {
      this.showError(this.dataset.errorGeneric);
      return;
    }

    // Dezelfde variant meerdere keuzes? Dan één regel met een hoger aantal.
    const counts = new Map();
    chosen.forEach((variant) => counts.set(variant.id, (counts.get(variant.id) || 0) + 1));
    const items = Array.from(counts, ([id, quantity]) => ({ id, quantity }));

    const config = fetchConfig('javascript');
    const payload = { items };

    if (this.cart) {
      payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = JSON.stringify(payload);

    this.setLoading(true);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.showError(response.description || response.message || this.dataset.errorGeneric);
          return;
        }

        if (!this.cart) {
          window.location = routes.cart_url;
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'skigrin-bundle', cartData: response });
        }

        if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        this.cart.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
        this.showError(this.dataset.errorGeneric);
      })
      .finally(() => this.setLoading(false));
  }
}

if (!customElements.get('skigrin-bundle')) {
  customElements.define('skigrin-bundle', SkigrinBundle);
}
